export const rangeCreator = (length: number): Array<any> => {
  return new Array(length);
};
